<mat-card>
  @if (showSpinner) {
    <mat-spinner color='primary' diameter="80" strokeWidth="4"></mat-spinner>
  }
  @if (url) {
    <iframe (load)="loadSuccess()" [src]="url | safe: 'resourceUrl'" allowtransparency
      data-hj-allow-iframe frameborder="0"
      onload="iFrameResize({checkOrigin:false, autoResize: true}, this)" style="background: #FFFFFF;">
    </iframe>
  }
</mat-card>
